import moment from "moment";
import { COUNTRY, GIFT_CARD_DELIVERY_FEE } from "../constants/app";
import { defaultMaxGiftAmount, GIFT_CARD_RESTRICTION_TYPE, GiftType, PROMO_ACTIONS, PROMO_TYPE } from "../models/giftcard";
import { ICartData, IGiftCardPromo } from "../store/giftshop/type";
import { validateGiftCartApi } from "../services/giftshop";

export const calTotal = (cartData: ICartData[], countryId: COUNTRY) => {
  let fee: number = 0;

  let total = cartData.reduce((sum: number, item: ICartData) => sum + item.itemTotal, 0);
  let phyCards = cartData
    .filter((item: ICartData) => item.giftcardType != GiftType.ecard);
    let phyTotal = phyCards.filter(
      (v, i, a) => a.findIndex((t: ICartData) => ((t.address1+t.address2+t.city+t.state+t.postCode).replace(/ /g,'').toLowerCase() === (v.address1+v.address2+v.city+v.state+v.postCode).replace(/ /g,'').toLowerCase()) && t.shippingDetails?.id === v.shippingDetails?.id) === i
    );

  if (countryId === COUNTRY.US || countryId === COUNTRY.AFC || countryId === COUNTRY.CON) {
    let totalFee = phyTotal.reduce((total:number,v:ICartData)=>{
       return Number(v.shippingDetails?.shippingFee) + total;
    },0) ;
    let deliveryFee = +totalFee;
    let deliveryQty = phyTotal.length;
    let finalAmount = (total + totalFee);
    return { deliveryFee, deliveryQty, total: finalAmount,deliveryCharge:0, shippingAddress: phyTotal.map((v:ICartData)=>({
      address1:v.address1,
      address2:v.address2,
      city:v.city,
      state:v.state,
      postCode:v.postCode,
      shippingDetails: v.shippingDetails
    }))}
  } else {
    if (countryId === COUNTRY.NZ) {
      fee = GIFT_CARD_DELIVERY_FEE.NZ;
    } else if (countryId === COUNTRY.ANG) {
      fee = GIFT_CARD_DELIVERY_FEE.ANG;
    } else if (countryId === COUNTRY.STA) {
      fee = GIFT_CARD_DELIVERY_FEE.STA;
    } else if (countryId === COUNTRY.AUS) {
      fee = GIFT_CARD_DELIVERY_FEE.AU;
    } 
    let totalFee = phyTotal.length * fee!;
    let deliveryFee = +totalFee;
    let deliveryQty = phyTotal.length;
    let finalAmount = (total + totalFee);
    return { deliveryFee, deliveryQty, total: finalAmount, deliveryCharge: fee, shippingAddress:[] }
  }

}


export const findGiftPromo = (giftPromo: [], amount: number, currentTab: string, giftPrice: number| null = null): IGiftCardPromo | undefined => {
  if(giftPromo.length > 0){
  const giftAmount = amount > defaultMaxGiftAmount ? defaultMaxGiftAmount : amount; 
    return giftPromo.find((v: any) => {
      return (
        (v.minimumSpendFlag === 1 &&
          giftAmount >= v.minimumSpendAmount &&
          (GIFT_CARD_RESTRICTION_TYPE[v.cardTypeRestriction] === currentTab || !v.cardTypeRestriction)) ||
        ((!v.minimumSpendFlag && GIFT_CARD_RESTRICTION_TYPE[v.cardTypeRestriction] === currentTab) && (!giftPrice || (giftPrice && giftAmount >= giftPrice))) ||
        (!v.minimumSpendFlag && !v.cardTypeRestriction && (!giftPrice || (giftPrice && giftAmount >= giftPrice)))
      );
    });
  }
  return undefined;
}

export const formatPromo = (value: any, promo: IGiftCardPromo) => {
  return {
    ...value,
    promoType: PROMO_TYPE.SEPARATE,
    promo: promo,
    quantity: 1,
    giftamount: 0,
    price: 0,
    tax: 0,
    itemTotal: 0,
    minimumVariablePriceInCents: 0,
    maximumVariablePriceInCents: 0,
    description: promo?.name,
    giftcardType: GiftType.ecard,
  };
};

export const formatGiftCard = (data: any) => {
  return data.map((v: any) => {
    return {
      ...v,
      IsVariablePriceItem: v.type === 2 ? true : false,
      MaximumVariablePriceInCents: "NaN",
      MinimumVariablePriceInCents: v.type === 2 ? v.minimum_amount : "NaN",
      description: v.name,
      image: v.image,
      shortImage: v.image,
      tax: "0.00",
      cardDescription: v.description
    }
  })
}


export const findMinPromo = (giftPromo: [],currentTab: string, giftPrice: number, cartData: ICartData[], isEdit = false) => {  
   const res = giftPromo.filter((v: any) => {
    return (
      (v.minimumSpendFlag === 1 &&
        (GIFT_CARD_RESTRICTION_TYPE[v.cardTypeRestriction] === currentTab || !v.cardTypeRestriction)) ||
      (!v.minimumSpendFlag && GIFT_CARD_RESTRICTION_TYPE[v.cardTypeRestriction] === currentTab) ||
      (!v.minimumSpendFlag && !v.cardTypeRestriction)
    );
  }).sort((a: IGiftCardPromo,b: IGiftCardPromo) => a.minimumSpendAmount - b.minimumSpendAmount);

  const [minAmntPromo] = res;
  let result: any= {};
  const availableConunt =  getPromoAvailableCount(minAmntPromo,cartData, false);
  /** Should not auggest the unavailable promo */
  if(availableConunt === null || availableConunt > 0 || isEdit){
    /** If minimumSpendFlag is not applied set minimumSpendAmount to giftcard price */
    if(minAmntPromo){
      result = minAmntPromo;
      if(!result?.minimumSpendFlag){
        result = {...result, minimumSpendAmount: giftPrice}
      }
    }
  }
   
  return result;
}

export const generatePromoList = (promoCount: number, promoCard: any, cartData:ICartData[]) => {

  let promoList = [];
  if(promoCount && promoCard){
    const existingPromoCount = cartData.filter((item: any) => item?.promo?.uniqueKey === promoCard?.promo?.uniqueKey)?.length;
    for(let i = 0; i < promoCount; i++){
      let first = false;
      let last = false;
      if(i === 0){
        first = true;
      }
      if(i === promoCount - 1){
        last = true;
      }
      const uuid = generateUniqueId();
      promoList.push({...promoCard, promoIndex: existingPromoCount + i + 1 ,isFirst: first, isLast: last, uuid, promoCountIndex: i + 1} );
    }

  }

  return promoList;
}

export const generateUniqueId = () => {
  const timestamp = new Date().getTime();  
  const randomNum = Math.floor(Math.random() * 10000);
  return `ID-${timestamp}-${randomNum}`; 
}

export const updateCart = (cartData: any, uniqueId: string, newData: any) => {
  const updatedData = cartData.map((item: any) => {
    if(item?.uuid === uniqueId){
      return {...newData}
    }
    return item;
  })

  return updatedData;
}




/**
 * availableConunt = null means promo has no limit 
 * availableConunt <= 0 means promo reached it's limit
*/
export const getPromoAvailableCount = (promo: any, cartData: ICartData[], isEdit: boolean = false, uuid: string = '') => {
  let availableConunt = null;
  if(promo?.limitAmount){
    availableConunt = promo?.limitAmount; // limitAmount = 0 means no limit
    if(availableConunt > 0){
      /** validating cart data */
      if(cartData && cartData.length > 0){
        const uniqueKey = promo?.uniqueKey;
        let existingCount = 0;
        if(isEdit && uuid !== ''){
          existingCount = cartData.filter((data: any) => data?.promo?.uniqueKey === uniqueKey && data?.parentId !== uuid).length;
        }else{
          existingCount = cartData.filter((data: any) => data?.promo?.uniqueKey === uniqueKey).length;
        }
        availableConunt -= existingCount;
      }
    }
  }
  return availableConunt;
}

/** fetch eligible promo count */
export const getEligiblePromoCount = (promo: any, giftCardAmount: number, quantity: number) => {
  let promoCount = 0;
  if(promo){

    if(quantity){
      /** Adding promo code based on number of gift card */
      /** Adding promo code based on additional increment */
      if(promo?.incrementFlag && promo?.incrementAmount > 1){
        const extraAmnt = giftCardAmount - promo?.minimumSpendAmount;
        if(extraAmnt >= promo?.incrementAmount){
          const increasedCount = Math.floor(extraAmnt/promo?.incrementAmount); // If res = 1.6666 val will be 1
          if(increasedCount > 0){
            promoCount += increasedCount;
          }
        }
      }
      /** Adding promo for minimum spend eligibility */
      promoCount+=1;
    }
    
    promoCount *= quantity;

  }

  return promoCount;
}
export const reOrderCartData = ((cartData: ICartData[], updatePrentId: boolean = true) => {
   let cardArray: ICartData[] = [];
   let promoObj: any = {};

    cartData.forEach((item: ICartData) => {
      if(item?.promo){
        const key = item.promo.uniqueKey;
        if (!promoObj[key]) {
          promoObj[key] = [];
        }
        promoObj[key].push(item);
      }else{
        cardArray.push(item);
      }
  });

  let updatedPromoObj: any = {};
  for(const k in promoObj){
    if (promoObj.hasOwnProperty(k)) {
      const valueArray = promoObj[k];
      const orderedPromo = valueArray.map((item: any, index: number) => {
        let first = false;
        let last = false;
        if(index === 0){
          first = true;
        }
        if(index === valueArray?.length - 1){
          last = true;
        }
        return {...item, promoIndex: index + 1, isFirst: first, isLast: last}
      });

      if (!updatedPromoObj[k]) {
        updatedPromoObj[k] = [];
      }
      updatedPromoObj[k].push(orderedPromo);
    }
  }
  const output: any =  Object.values(updatedPromoObj).flat(2);
  const result = [...cardArray, ...output];
  if(updatePrentId){

    const updatedResult = applyParentId(result);
    return updatedResult;
  }
  return result;
});

export const calculatePromoCount = (promo: any, cartData: ICartData[], giftCardAmount: number, quantity: number, isEdit: boolean = false, uuid: string = '') => {
  const amount  = giftCardAmount > defaultMaxGiftAmount ? defaultMaxGiftAmount: giftCardAmount;
  const eligibleCount = getEligiblePromoCount(promo, amount, quantity);
  const availableConunt = getPromoAvailableCount(promo, cartData, isEdit, uuid);
  let promoCount = 0;
  if(availableConunt === null){ 
    promoCount = eligibleCount;
  }else{
    if(availableConunt > 0){
      promoCount  = availableConunt > eligibleCount ? eligibleCount : availableConunt;
    }
  }
  return {eligibleCount, availableCount: promoCount};
}

export const reCalculatePromoEligibility = (cartData: ICartData[], promo:any) => {
  let promoArray: ICartData[] = [];
  let eligibleCount: number = 0;
  let cartArray = [...cartData];
  cartArray.forEach((item: ICartData) => {
    if(item?.promo){
      if(item?.promo?.uniqueKey === promo?.uniqueKey){
        promoArray.push(item);
      }
    }else{
      if(item?.promoDetails?.uniqueKey === promo?.uniqueKey && item?.promoDetails?.isEligible){
        eligibleCount += item?.promoDetails?.eligibleCount;
      }
    }
  });

  const diff = eligibleCount - promoArray?.length;
  let actionCount = diff;
  // if diff < 0 means need to remove diff number of promo
  let action= PROMO_ACTIONS.NONE; // none means no action needed
  if(diff < 0){
    if(eligibleCount === 0){
      action = PROMO_ACTIONS.REMOVE_ALL;
    }else{
      action = PROMO_ACTIONS.REMOVE;
    }
  }else if(diff > 0){
    if(promo?.limitAmount === 0){ // no limit
      action = PROMO_ACTIONS.ADD;
    } else if(promo?.limitAmount > 0 && promo?.limitAmount > promoArray?.length){ // limit not exceeded
      action = PROMO_ACTIONS.ADD;
      actionCount = promoArray?.length + diff > promo?.limitAmount ? promo?.limitAmount - promoArray?.length : diff;
    }
  }
  return {action, actionCount, promoArray, cartData: cartArray};
}
export const validateGiftAmount = (data: any) => {
  const {isVariablePriceItem, maximumVariablePriceInCents, minimumVariablePriceInCents, price, giftamount} = data;
  let amount = 0;
  if (isVariablePriceItem) {
      if (Number(giftamount) > maximumVariablePriceInCents) {
        amount = maximumVariablePriceInCents;
      } else if (
        Number(giftamount) < minimumVariablePriceInCents
      ) {
        amount = minimumVariablePriceInCents;
      }else{
        amount = giftamount;
      }
    } else {
      if (Number(giftamount) > defaultMaxGiftAmount) {
        amount = defaultMaxGiftAmount;
      } else if (Number(giftamount) < price) {
        amount = price;
      }else{
        amount = giftamount;
      }
    }
    return amount;
}

export const applyParentId = (cartData: ICartData[]) => {
  const promoObj: any = {};
  const cardArray: any = [];
  const cartArray = [...cartData];
  if(cartArray?.length > 0){
    cartArray.forEach((cartItem: any) => {
      if(cartItem?.promo){
        if(!promoObj[cartItem?.promo?.uniqueKey]){
          promoObj[cartItem?.promo?.uniqueKey] = [];
        }
        promoObj[cartItem?.promo?.uniqueKey].push(cartItem);
      }else{
        cardArray.push(cartItem);
      }
    });

    let updatedPromo: any = [];

    if(cardArray?.length > 0){
      cardArray?.forEach((card: ICartData) => {
        const promoUniqueKey = card?.promoDetails?.uniqueKey;
        if(promoUniqueKey && promoObj[promoUniqueKey]){
          const eligibleCount = card?.promoDetails?.eligibleCount;
          const promoArr = promoObj[promoUniqueKey];
          const updatingPromo = promoArr.splice(0, eligibleCount);
          const eligiblePromos = updatingPromo?.map((item: any) => ({...item, parentId: card?.uuid}));
          updatedPromo = [...updatedPromo, ...eligiblePromos];
          promoObj[promoUniqueKey] = promoArr;
        }
      });
    }
    return [...cardArray, ...updatedPromo];
  }else{
    return cartArray;
  }
}

export const validateCart = async(cartData: any, cinemaId: string, countryId: string) => {
  
  /**
   *  All paid (Physical/Digital) gift cards are still 'in stock'.
      All E-Gift Card Delivery Dates are today or future dates (i.e. no Delivery Dates are historic).
      All Bonus Cards in the Cart (if any) are from promos that are still active.
      There have been no changes with active promos.
   */
  let isExpired = false; // become true when deliveryDate is expired
  let isUnavailable = false; // become true when data unavailable
  let itemModified = false; // become true when data modified 
  if(cartData?.length > 0){
    const payload = {
      "countryId": countryId,
      "cinemaId": cinemaId,
      "cart":[...cartData]
    }
    const response = await validateGiftCartApi(payload);
    if(response?.status === 200){
      return response?.data
    }
  }
  return {isExpired, isUnavailable, itemModified};
}

